import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './FooterPages.css';

const AboutUs = () => {
    return (
        <div className="footer-page-container">
            <div className="footer-page-inner">
                <Link to="/" className="footer-back-btn">
                    <FaArrowLeft /> Back to Home
                </Link>

                <div className="footer-header">
                    <h1 className="footer-title">About Us</h1>
                    <p className="footer-subtitle">
                        Bridging the gap between Academic Theory and Industry Reality.
                    </p>
                </div>

                <div className="footer-text-section">
                    <h2 style={{ color: '#818cf8', fontSize: '2rem', marginBottom: '1rem' }}>Our Mission</h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                        At EdVergenceX, we believe that the future of education lies in the seamless integration of classroom learning and real-world application. Our mission is to democratize access to industry expertise, enabling every student to learn from the builders, creators, and leaders of today's economy. We empower institutions to easily adopt the Professor of Practice model, enriching their faculty with seasoned professionals.
                    </p>
                </div>

                <div className="footer-text-section">
                    <h2 style={{ color: '#818cf8', fontSize: '2rem', marginBottom: '1rem' }}>The Story</h2>
                    <p style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                        Born from the observation that academic curriculums often struggle to keep pace with rapid industrial advancements, EdVergenceX was founded to create a direct pipeline of knowledge. We recognized the untapped potential of professionals willing to teach and institutions eager to innovate. Today, we stand as the premier platform for facilitating these high-impact academic engagements.
                    </p>

                </div>

                <div className="footer-text-section">
                    <h2 style={{ color: '#818cf8', fontSize: '2rem', marginBottom: '1.5rem' }}>Our Values</h2>
                    <ul style={{ listStyleType: 'none', padding: 0, display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                        {['Excellence', 'Integrity', 'Innovation', 'Accessibility', 'Collaboration'].map(val => (
                            <li key={val} style={{
                                background: 'rgba(30, 41, 59, 0.6)',
                                padding: '12px 24px',
                                borderRadius: '30px',
                                color: 'var(--proto-white)',
                                fontWeight: '600',
                                border: '1px solid rgba(71, 85, 105, 0.5)',
                                backdropFilter: 'blur(8px)',
                                transition: 'all 0.3s ease'
                            }}
                                onMouseEnter={(e) => { e.currentTarget.style.borderColor = '#818cf8'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.borderColor = 'rgba(71, 85, 105, 0.5)'; e.currentTarget.style.transform = 'translateY(0)'; }}
                            >
                                {val}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default AboutUs;


